export { default as UnitsMetricInSolidIcon } from './UnitsMetricInSolidIcon';
